import { FullWidthCTA } from '@cinch-labs/design-system'
import { useVehicleCount } from '@cinch-nx/search-shared'
import type {
  ArticlePreview,
  GuidesHubPageStoryContent,
} from '@cinch-nx/landing-ui-articles'
import { ArticleHeader } from '@cinch-nx/landing-ui-articles'
import { renderWithResolver } from '@cinch-nx/landing-ui-shared'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'
import { Wrapper } from '@cinch-nx/shared-ui'
import { useRouter } from 'next/router'

import { ArticlesPreview } from './components'
import styles from './guides-hub.module.css'

export interface GuidesHubFeatureProps {
  content: GuidesHubPageStoryContent
  recentArticleStories: {
    [key: string]: ArticlePreview[]
  }
}

export const GuidesHubFeature = ({
  content,
  recentArticleStories,
}: GuidesHubFeatureProps) => {
  const { vehicleCount } = useVehicleCount()
  const router = useRouter()
  const numberOfCars = new Intl.NumberFormat('en-GB').format(vehicleCount ?? 0)

  const renderArticlesPreview = () =>
    Object.entries(recentArticleStories).map(([key, articles]) => (
      <ArticlesPreview key={key} slug={key} articles={articles} />
    ))

  const { trackEvent } = useAnalytics()

  const handleClick = () => {
    trackEvent({
      eventName: `Guides-  click search all cars button`,
      type: TrackingEventTypes.ADOBE,
      data: {
        event: {
          name: EventNames.click,
          category: 'guides page',
          label: 'button in page',
          action: 'view all cars',
        },
      },
    })
    router.push('/used-cars')
  }
  return (
    <article
      className={styles.page}
      data-testid={`feature-article-${content.title}`}
    >
      <Wrapper isSlim>
        <ArticleHeader title={content.title} subTitle={content.subtitle} />
        {renderArticlesPreview()}
      </Wrapper>
      {content.seoSection ? (
        <Wrapper isSlim className={{ inner: styles.seoSection }}>
          {renderWithResolver(content.seoSection)}
        </Wrapper>
      ) : null}
      <FullWidthCTA
        iconName="search"
        iconGradient="galaxy"
        iconSize={41}
        title="Let’s find your next car"
        subtitle="Ready to hit the open road?"
        buttonLabel={`Search all ${numberOfCars} cars`}
        onButtonClick={handleClick}
        className={styles.fullWidthCta}
      ></FullWidthCTA>
    </article>
  )
}
